module.exports = "<div class=\"footer\">\r\n    <div class=\"container-fluid\">\r\n        <p class=\"copyright pull-right\">\r\n            &copy; {{test | date: 'yyyy'}} <a href=\"https://www.kelanicables.com/\">Kelani Cables PLC</a>, Cable Size Calculator\r\n        </p>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = 187
// module chunks = 1